export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AML проверка"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите адрес и выберите блокчейн — выполним быстрый скрининг."])}
}